export enum CandidateStatus {
  Expired = "Expired", // no valid certificate and no ongoing exam
  Valid = "Valid", // valid certificate and no ongoing exam
  OnGoing = "OnGoing", // ongoing exam
}
